import React, { useState } from "react";
import { UploadOutlined, UserOutlined, HeartOutlined } from "@ant-design/icons";

const UploadPefindoModal = ({
  visible,
  onClose,
  applicationId,
  nik,
  nama,
  nikpasangan,
  namaPasangan,
  onSuccess,
}) => {
  const [filePemohon, setFilePemohon] = useState(null);
  const [filePasangan, setFilePasangan] = useState(null);
  const [loading, setLoading] = useState(false);

  const API_BASE_URL2 = import.meta.env.VITE_BASE_URL2;
  const API_BASE_URL = import.meta.env.VITE_BASE_URL;

  // Handler untuk file pemohon
  const handleFilePemohonChange = (e) => {
    if (e.target.files && e.target.files[0]) {
      setFilePemohon(e.target.files[0]);
    }
  };

  // Handler untuk file pasangan
  const handleFilePasanganChange = (e) => {
    if (e.target.files && e.target.files[0]) {
      setFilePasangan(e.target.files[0]);
    }
  };

  const handleSubmitUpload = async () => {
    if (!filePemohon && !filePasangan) {
      return alert("Minimal satu file harus diupload.");
    }

    const formData = new FormData();
    if (filePemohon) formData.append("pefindo_pemohon", filePemohon);
    if (filePasangan) formData.append("pefindo_pasangan", filePasangan);

    try {
      setLoading(true);
      const response = await fetch(
        `${API_BASE_URL}/api/pemohon/upload-pefindo/${applicationId}`,
        {
          method: "POST",
          body: formData,
        }
      );
      const data = await response.json();
      if (response.ok) {
        alert("Upload berhasil!");
        onClose();
        if (onSuccess) onSuccess();
      } else {
        alert(data.message || "Upload gagal");
      }
    } catch (error) {
      console.error("Upload error:", error);
      alert("Terjadi kesalahan saat upload.");
    } finally {
      setLoading(false);
    }
  };

  if (!visible) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-30 flex items-center justify-center z-50">
      <div className="bg-white rounded-lg p-6 w-[500px] shadow-xl">
        <h2 className="text-2xl font-bold mb-6 text-center text-gray-700">
          Upload File Pefindo
        </h2>

        {/* PEMOHON */}
        <div className="mb-6 border-b pb-4">
          <div className="flex items-center gap-2 mb-3 text-blue-600">
            <UserOutlined className="text-xl" />
            <h3 className="text-xl font-semibold">Pemohon</h3>
          </div>

          <div className="text-base text-gray-800 space-y-1 mb-2 ml-5">
            <div>
              <span className="font-bold text-lg inline-block w-24">NIK</span>:{" "}
              {nik}
            </div>
            <div>
              <span className="font-bold text-lg inline-block w-24">Nama</span>:{" "}
              {nama}
            </div>
          </div>

          <div className="ml-5">
            <label
              htmlFor="filePemohon"
              className="cursor-pointer inline-block bg-blue-500 hover:bg-blue-600 text-white font-semibold py-2 px-4 rounded"
            >
              <UploadOutlined className="mr-2" />
              Choose File
            </label>
            <input
              id="filePemohon"
              type="file"
              accept="application/pdf"
              onChange={handleFilePemohonChange}
              className="hidden"
            />
            {filePemohon && (
              <p className="mt-2 text-sm text-gray-600">{filePemohon.name}</p>
            )}
          </div>
        </div>

        {/* PASANGAN */}
        {nikpasangan && (
          <div className="mb-4">
            <div className="flex items-center gap-2 mb-3 text-pink-600">
              <HeartOutlined className="text-xl" />
              <h3 className="text-xl font-semibold">Pasangan</h3>
            </div>

            <div className="text-base text-gray-800 space-y-1 mb-2 ml-5">
              <div>
                <span className="font-bold text-lg inline-block w-24">NIK</span>
                : {nikpasangan}
              </div>
              <div>
                <span className="font-bold text-lg inline-block w-24">
                  Nama
                </span>
                : {namaPasangan}
              </div>
            </div>

            <div className="ml-5">
              <label
                htmlFor="filePasangan"
                className="cursor-pointer inline-block bg-pink-500 hover:bg-pink-600 text-white font-semibold py-2 px-4 rounded"
              >
                <UploadOutlined className="mr-2" />
                Choose File
              </label>
              <input
                id="filePasangan"
                type="file"
                accept="application/pdf"
                onChange={handleFilePasanganChange}
                className="hidden"
              />
              {filePasangan && (
                <p className="mt-2 text-sm text-gray-600">
                  {filePasangan.name}
                </p>
              )}
            </div>
          </div>
        )}

        {/* Footer */}
        <div className="flex justify-end gap-3 pt-4 border-t mt-4">
          <button
            onClick={onClose}
            className="px-4 py-1 rounded bg-gray-500 text-white hover:bg-gray-600"
          >
            Tutup
          </button>
          <button
            onClick={handleSubmitUpload}
            disabled={loading}
            className="px-4 py-1 rounded bg-blue-600 text-white hover:bg-blue-700 disabled:bg-blue-300"
          >
            {loading ? "Mengunggah..." : "Upload"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default UploadPefindoModal;
